<template>
    <div class="position-relative">
        <div class="row" v-if="radioButtons === true">
            <div class="col-12 col-sm-6" v-for="result in options">
                <div class="form-check form-check-inline">
                    <b-form-radio data-hj-whitelist v-model="selected" class="form-check-input" :value="result.value">{{result.label}}</b-form-radio>
                </div>
            </div>
            <br />
        </div>
        <select v-if="radioButtons !== true" v-model="selected" class="custom-select custom-select-sm" :id="id" :disabled="loaded === null">
            <option v-for="result in results" :value="result.value">{{result.label}}</option>
        </select>
        <em class="fa fa-sync fa-spin position-absolute loader" v-show="loaded===null"></em>
    </div>
</template>

<script>
    export default {
        components: {
        },
        data() {
            return {
                results: [],
                selected: null,
                loaded: null,
                errors: [],
                q: ''
            }
        },
        props: {
            value: [Number, null],
            type: [String],
            radioButtons: {
                type: Boolean,
                default: false
            },
            forCreate: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            results() {
                this.$store.commit('selectedStore/selected', {
                    results: this.results,
                    type: this.type
                });
            },
            selected(n, o) {
                this.$emit('input', n);
            },
            value(n, o) {
                this.selected = this.value;
            }
        },
        mounted() {
            if(this.value) {
                this.selected = this.value;
            }
            if(this.$store.getters['selectedStore/selected'](this.type)) {
                this.results = this.$store.getters['selectedStore/selected'](this.type);
                this.loaded = new Date();
            } else {
                this.refresh();
            }
        },
        computed: {
            options() {
                if(this.forCreate === true) {
                    let options = [];
                    for(let index in this.results) {
                        if(this.results.hasOwnProperty(index) && this.results[index].for_create === true) {
                            options.push(this.results[index])
                        }
                    }
                    return options;
                }
                return this.results;
            }
        },
        methods: {
            getResults() {
                return this.results;
            },
            refresh() {
                this.showing = null;
                this.loaded = null;
                this.errors = [];

                axios.get('/api/v1/leads/ep/' + this.type)
                    .then(response => {
                        this.loaded = new Date();
                        this.results = response.data;
                    })
                    .catch(error => {
                        this.loaded = new Date();
                        if (typeof error.response.data === 'object') {
                            if(error.response.data.errors) {
                                this.errors = _.flatten(_.toArray(error.response.data.errors));
                            } else {
                                this.errors = [error.toString()];
                            }
                        } else {
                            this.errors = ['Something went wrong. Please try again.'];
                        }
                    })
            }
        }
    }
</script>

<style lang="scss">
    .loader {
        margin-top: -22px;
        margin-left: 12px;
    }

    .custom-control-label {
        line-height: 26px;
    }

    .custom-control-label::before, .custom-control-label::after {
        top: 5px;
    }
</style>